import { DetailCard } from '#components/atoms/cards/detail-card/DetailCard.tsx';
import { RoleLink } from '#components/patterns/entity-links/role-link/RoleLink.tsx';
import { InlineTagsList } from '#components/patterns/tags/InlineTagsList.tsx';
import type { Host } from '#dn-types/host.ts';
import { sortIpsV6First } from '#util/hostIps.ts';
import { ClientVersion } from '../../hosts-table/ClientVersion.tsx';
import styles from './DebugHeader.module.css';

type Props = {
  host: Host;
  dataUpdatedAt: Date;
};

export function DebugHeader({ host, dataUpdatedAt }: Props) {
  const ipLabel = host.ipAddresses.length === 1 ? 'IP address' : 'IP addresses';
  return (
    <DetailCard className={styles.DebugHeader}>
      <dl className="flex flex-wrap m-0 p-md align-center">
        <span className="mr-24">
          <dt className="inline mr-8 weight-semibold">{ipLabel}</dt>
          <dd className="inline ml-0">{sortIpsV6First(host.ipAddresses).join(', ')}</dd>
        </span>
        <span className="mr-24">
          <dt className="inline mr-8 weight-semibold">Client version</dt>
          <dd className="inline ml-0">
            <ClientVersion className="inline" host={host} dataUpdatedAt={new Date(dataUpdatedAt)} />
          </dd>
        </span>
        <span className="mr-24 truncate">
          <dt className="inline mr-8 weight-semibold">Role</dt>
          <dd className="inline ml-0 mw-0">
            {host.roleID ?
              <RoleLink roleID={host.roleID} className="inline truncate" />
            : 'No role'}
          </dd>
        </span>
        <span className="inline-flex truncate align-center">
          <dt className="inline mr-8 weight-semibold">Tags</dt>
          <dd className="inline-flex ml-0 width-100">
            {host.tags.length > 0 ?
              <InlineTagsList tagNames={host.tags} truncateAfter={2} />
            : 'No tags'}
          </dd>
        </span>
      </dl>
    </DetailCard>
  );
}
